import { makeStyles, } from '@material-ui/core/styles';

const removeArrows = {
    '-webkit-appearance': 'none',
    margin: 0,
};

export const makeInputMobilePaginationStyles = makeStyles({
    root: {
        height: 25,
        maxWidth: 42,
        marginRight: 8,
        marginLeft: 8,
    },

    input: {
        padding: 8,
        fontSize: '0.85rem',
        '-moz-appearance': 'textfield',
        '&::-webkit-outer-spin-button': removeArrows,
        '&::-webkit-inner-spin-button': removeArrows,
    }
}, { index: 1, });
